import { Input as ChakraInput } from '@chakra-ui/react';
import { FormControlOptions, PolymorphicProps, StyleProps, SystemProps, ThemingProps } from './primitives.types';

export interface InputProps extends
  SystemProps,
  PolymorphicProps,
  FormControlOptions,
  ThemingProps,
  Omit<React.ComponentPropsWithoutRef<'input'>, keyof StyleProps | keyof FormControlOptions | keyof ThemingProps> {
}

export function Input(props: InputProps) {
  return <ChakraInput {...props} />;
}